export const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

export const endPoints = {
  login: "login",
  callBackRequest: "user/callBack-request",
  callBackRequestDevelopment: "user/callBack-request-development",

  // Legal Content
  legalContent: "web/legal-content/:type"
};

export const mediaUrl =
  "https://amberstore-bucket.s3.eu-north-1.amazonaws.com/";

export const constants = {};
